var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.98409,
    cy: 8.01632,
    r: 4.738,
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90575 8.03198C9.90575 9.08463 9.05241 9.93798 7.99975 9.93798C6.9471 9.93798 6.09375 9.08463 6.09375 8.03198C6.09375 6.97932 6.9471 6.12598 7.99975 6.12598C9.05241 6.12598 9.90575 6.97932 9.90575 8.03198Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5441V0.704102",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3117V13.4717",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51188 8.03223H0.671875",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3127 8.03223H13.4727",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLocation);
export default __webpack_public_path__ + "static/media/chooseLocation.1890c57e5a1f024c4ed617229d360a14.svg";
export { ForwardRef as ReactComponent };